import React, { useCallback, useEffect } from 'react';

import { View } from 'react-native';

import PinDialog, { PinDialogRef } from 'components/PinDialog';
import usePinDialogStatus from 'components/PinDialog/hooks/usePinDialogStatus';
import { PinDialogProps } from 'components/PinDialog/types';

import styles from './styles';

export default function GenericPinDialog({
    modal = false,
    visible,
    appState,
    onSuccess,
    onClose,
    wasFullScreen,
}: Pick<PinDialogProps, 'appState' | 'visible' | 'onClose' | 'modal'> & {
    onSuccess(): boolean | void;
    wasFullScreen?: boolean;
}) {
    const pinDialogRef = React.useRef<PinDialogRef>(null);

    const { pinDialogStatus, onResetPinStatus, onValidatePin } =
        usePinDialogStatus(pinDialogRef, visible, onClose);

    const handleClose = useCallback(() => {
        onResetPinStatus();
        onClose();
    }, [onClose, onResetPinStatus]);

    const handleValidPin = useCallback(() => {
        onResetPinStatus();
        onSuccess();
    }, [onResetPinStatus, onSuccess]);

    const handleSubmit = useCallback(
        (pin: string) => {
            onValidatePin({
                pin,
                onPinValid: handleValidPin,
            });
        },
        [onValidatePin, handleValidPin],
    );

    useEffect(() => {
        if (visible && wasFullScreen) {
            setTimeout(() => {
                pinDialogRef.current?.focus();
            }, 0);
        }
    }, [visible, wasFullScreen]);

    if (visible) {
        return (
            <View style={styles.notificationContainer}>
                <PinDialog
                    modal={modal}
                    appState={appState}
                    ref={pinDialogRef}
                    visible={visible}
                    haveToShowCloseButton
                    onClose={handleClose}
                    onSubmit={handleSubmit}
                    status={pinDialogStatus}
                />
            </View>
        );
    }

    return null;
}
